/**
 * Datapoint configurations.
 */
export default {
    ReminderDefaultOption: {
        datapoint: {
            name: 'ReminderDefaultOption',
            customData: (reminderDuration: number) => [reminderDuration],
        },
    },

    EventDurationDefaultOption: {
        datapoint: {
            name: 'EventDurationDefaultOption',
            customData: (eventDuration: number) => [eventDuration],
        },
    },
};
